<template>
  <div>
    <notification-template
      :large="large"
      :hash="notification.id"
      :urlProfilePhoto="teacher.urlProfilePhoto">
      <template v-slot:header>
        {{$t('notifications.startLessonTitle')}}
      </template>
      <div>
        <p>
          {{$t('notifications.teacher')}}
          <router-link :to="`/teachers/${teacher.slug}`" class="font-medium">
            {{ teacher.name }}
          </router-link>
          {{$t('notifications.startLesson')}}
        </p>
      </div>
      <template v-slot:actions>
        <button class="rounded-sm p-2 text-white uppercase
          bg-gradient-to-r from-orange-academy-300 to-gray-500 hover:from-gray-500
          hover:to-orange-academy-300"
          @click="startLesson" :class="isLoading ? 'loader' : ''"
        >
          {{$t('masterclass.start')}}
        </button>
      </template>
    </notification-template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getStudentUrl } from '@/services/LessonService';
import NotificationTemplate from './NotificationTemplate.vue';

export default {
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
    large: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      lesson: { ...this.notification.data.lesson },
      teacher: { ...this.notification.data.teacher },
      isLoading: false,
    };
  },
  components: {
    NotificationTemplate,
  },
  methods: {
    ...mapActions({
      toggleNotifications: 'toggleNotifications',
    }),
    startLesson() {
      this.isLoading = true;
      getStudentUrl(this.lesson.booking_id).then(({ data }) => {
        window.location.href = data;
        this.isLoading = false;
      }).catch((errors) => {
        this.isLoading = false;
        console.log(errors);
      });
    },
    goToDashboard() {
      if (!this.large) {
        this.toggleNotifications();
        this.$router.push(`/student-dashboard#${this.notification.id}`).catch(() => {});
      }
    },
  },
};
</script>
